import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import axios from "axios";
import moment from "moment";

import { IoChevronDownOutline } from "react-icons/io5";

import {
  activityType,
  changeType,
  formatDate,
  groupHistories,
  parseChangeData,
} from "../../common/function/project";

import { ProjectDetailSection, ProjectHistoryContainer } from "../../common/styled/project";

const History = () => {
  const { projectNo } = useParams();
  const [histories, setHistories] = useState({});
  const [toggle, setToggle] = useState([]);

  const getHistories = async () => {
    try {
      const res = await axios.post("/api/projectHistory", { projectNo });
      if (res.status === 200) {
        const data = res.data;

        const grouped = groupHistories(data);
        const firstKey = Object.keys(grouped)[0];

        setHistories(grouped);
        setToggle(firstKey ? [firstKey] : []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getHistories();
  }, []);

  const toggleDate = (date) => {
    setToggle((prev) => (prev.includes(date) ? prev.filter((d) => d !== date) : [...prev, date]));
  };

  return (
    <ProjectDetailSection>
      <ProjectHistoryContainer>
        <ul className="histories">
          {Object.entries(histories).map(([date, items]) => (
            <li key={date}>
              <h4>
                <span>{moment(date).format("YYYY년 M월 D일 dddd")}</span>
                <button
                  onClick={() => toggleDate(date)}
                  className={toggle.includes(date) ? "active" : "inactive"}>
                  <IoChevronDownOutline />
                </button>
              </h4>
              <ul className={toggle.includes(date) ? "active" : "inactive"}>
                {items.map((history) => (
                  <li key={history.activityNo}>
                    <p className="tit">
                      <span>{activityType[history.activityType]}</span>
                      <span>{formatDate(history.createdAt)}</span>
                    </p>
                    <p className="message">
                      <strong>{history.createdBy}</strong>님이{" "}
                      {chooseParticle(
                        activityType[history.activityType] || history.activityType,
                        "을를",
                      )}{" "}
                      {history.changeType && !["KICK", "INVITE"].includes(history.activityType) && (
                        <strong>{changeType[history.changeType] || history.changeType}</strong>
                      )}
                      하였습니다.
                    </p>
                    <div className="data">
                      {parseChangeData(history.changeData, history.changeType)}
                    </div>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </ProjectHistoryContainer>
    </ProjectDetailSection>
  );
};

export default History;
